"use client"

import { ReactNode } from "react"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"
import { useI18n } from "@/components/providers/I18nProvider"

interface FormSectionProps {
  title: string
  description?: string
  children: ReactNode
  className?: string
}

export function FormSection({
  title,
  description,
  children,
  className
}: FormSectionProps) {
  const { t } = useI18n()
  const titleContent = t(title)
  const descriptionContent = description ? t(description) : description

  return (
    <div className={cn("mb-6 last:mb-0", className)}>
      <div className="mb-4">
        <Label className="text-base font-medium block mb-1">
          {titleContent}
        </Label>
        {descriptionContent && (
          <p className="text-sm text-muted-foreground">
            {descriptionContent}
          </p>
        )}
      </div>
      <div className="space-y-3">
        {children}
      </div>
    </div>
  )
}
